export default [
    "31.2 22.4",
    '<path fill="none" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M2.1,15.4c0.3-0.1,0.5-0.4,0.6-0.6c0.2-0.3,0.2-0.7,0.2-1.5V9.2c0-0.8,0-1.2-0.2-1.5C2.6,7.4,2.3,7.1,2.1,7\n' +
    'M6.2,21.1L19.5,7.8c0.4-0.4,0.6-0.6,0.8-0.7c0.2-0.1,0.4-0.1,0.6,0c0.2,0.1,0.4,0.3,0.8,0.7l8.3,8.3 M30.2,16.7V5.7\n' +
    'c0-1.6,0-2.5-0.3-3.1c-0.3-0.5-0.7-1-1.3-1.3C28,1,27.1,1,25.5,1H5.7C4,1,3.2,1,2.6,1.3C2,1.6,1.6,2,1.3,2.6C1,3.2,1,4,1,5.7v11.1\n' +
    'c0,1.6,0,2.5,0.3,3.1c0.3,0.5,0.7,1,1.3,1.3c0.6,0.3,1.4,0.3,3.1,0.3h19.8c1.6,0,2.5,0,3.1-0.3c0.5-0.3,1-0.7,1.3-1.3\n' +
    'C30.2,19.2,30.2,18.4,30.2,16.7z M15.1,5.2c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2C14.2,3.2,15.1,4.1,15.1,5.2z"/>'
]

